<template>
  <div id="app">
    <!-- 一级路由 -->
    <router-view />

    <!-- 加载 -->
    <div v-if="loading" id="loading">
      <van-loading>加载中...</van-loading>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
// eslint-disable-next-line
// import vConsole from "./utils/vconsole";
export default {
  data: () => ({
    //高亮索引值
    active: 0
  }),
  computed: {
    ...mapState({
      loading: state => state.loading
    })
  }
};
</script>

<style lang="less">
html,
body,
ul,
ol,
p,
h1,
h2,
h3,
h4,
h5,
h6,
form,
div,
li {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  font-family: "微软雅黑";
}
ul,
ol {
  list-style: none;
}
a {
  text-decoration: none;
}

.btn {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

#loading {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 51;
  width: 100%;
  height: 100%;
  background-color: rgba(7, 17, 27, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;

  .van-loading {
    color: #fff;
    font-size: 24px;
  }

  .van-loading__text {
    color: #fff;
  }
}

.filter-loading {
  filter: blur(8px);
}
</style>
